import { render, staticRenderFns } from "./embed-item.vue?vue&type=template&id=b1fb3cfc&scoped=true&"
import script from "./embed-item.vue?vue&type=script&lang=js&"
export * from "./embed-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1fb3cfc",
  null
  
)

export default component.exports